export default {
  s: '%d δευτερόλεπτο',
  smicro: '%d δ',
  smid: '%d δευτ',

  ss: '%d δευτερόλεπτα',
  ssmicro: '%d δ',
  ssmid: '%d δευτ',

  m: '%d λεπτό',
  mmicro: '%d λ',
  mmid: '%d λεπ',

  mm: '%d λεπτά',
  mmmicro: '%d λ',
  mmmid: '%d λεπ',

  h: '%d ώρα',
  hmicro: '%d ώ',
  hmid: '%d ώρα',

  hh: '%d ώρες',
  hhmicro: '%d ώ',
  hhmid: '%d ώρες',

  d: '%d ημέρα',
  dmicro: '%d η',
  dmid: '%d ημέρα',

  dd: '%d ημέρες',
  ddmicro: '%d η',
  ddmid: '%d ημέρες',
};
